import { render } from "./Privacy.vue?vue&type=template&id=2cf2dffd"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__